// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
import { SidebarSimple } from "@phosphor-icons/react";
import { IconButton } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

type AskV2RailToggleProps = {
  open: boolean;
  onToggle: () => void;
};

export function AskV2RailToggle({ open, onToggle }: AskV2RailToggleProps) {
  const { t } = useTranslation("ui");
  const label = open ? t("askV2.rail.hide") : t("askV2.rail.show");

  return (
    <IconButton
      type="button"
      variant="ghost"
      color="gray"
      size="2"
      onClick={onToggle}
      aria-label={label}
      aria-pressed={open}
      data-testid="ask-v2-rail-toggle"
      className="shrink-0 text-puntt-neutral-gray-11"
    >
      <SidebarSimple size={16} mirrored />
    </IconButton>
  );
}
